import React, { Component } from "react";
import ElectronicVerification from "@formatic/electronic-verification";
import AbnLookupComponent from "@formatic/abn-lookup";
import { Overrides, Data, Events } from "@formatic/sdk";
import PropTypes from "prop-types";
import FormaticSDK from "@formatic/sdk";
import get from "lodash/get";

import AustralianUnityLayout from "./layouts/AustralianUnity";
import DjprLayout from './layouts/djpr'
import {ParamsFromURL} from './javascript/common';

import CustomDropdown from "./components/CustomDropdown";

const formProps = {
  apiServerUrl: "https://api.transformd.com",
  serverUrl: "https://api.transformd.com/graphql",
  subscriptionServerUrl: "wss://api.transformd.com/subscriptions",
};

const data = new Data();

const params = ParamsFromURL();
const sessionId = get(params,"session_id",null);

const getDataHelper = () => data;

class App extends Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    const dataHelper = getDataHelper();

    dataHelper.getEmitter().on(Events.ValueChanged, (data) => {
      // Only want ABN: 5f2bc28732bbd9009224977b
      if (get(data, "fieldID") !== "5f2bc28732bbd9009224977b") {
        return;
      }

      // Will reset to blank if new search is clicked, etc
      const abn = get(data, "newValue.abn.result.abn") || "";
      const entityName = get(data, "newValue.abn.result.entityName") || "";

      dataHelper.setFieldValue("5f2bafd132bbd90091597065", `${abn}`); // machineTag: abn
      dataHelper.setFieldValue("5f2baae30e45680090171104", `${entityName}`); // machineTag: businessName
    });
  }

  render() {
    const { branch, channel, apiKey, formId } = this.props;

    return (
      <AustralianUnityLayout formId={"598"}>
        <div className="container">
          <div className="page__example-fsf">
            <FormaticSDK
              {...formProps}
              formId={formId}
              data={data}
              apiKey={apiKey}
              environment={branch}
              channel={channel}
              config="default"
              theme="transformd"
              submissionId={sessionId}
            >
              <Overrides.OverrideFieldContainer
                component={AbnLookupComponent}
                type="abnLookup"
              />
              <Overrides.OverrideFieldContainer
                type="customDropDown"
                component={CustomDropdown}
                getData={getDataHelper}
              />
            </FormaticSDK>
          </div>
        </div>
      </AustralianUnityLayout>
    );
  }
}

App.propTypes = {
  formId: PropTypes.string,
  channel: PropTypes.string,
  branch: PropTypes.string,
  apiKey: PropTypes.string,
};

App.defaultProps = {
  formId: 665,
  channel: "master",
  branch: "Development",
  apiKey: "",
};

export default App;
